/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type StarIconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function StarIcon(props: StarIconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 18 17"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        fill={"#FFE81A"}
        stroke={"#FDE047"}
        d={
          "M10.657 5.719a1 1 0 0 0 .951.691h5.364l-4.34 3.153a1 1 0 0 0-.362 1.118l1.657 5.1-4.34-3.152a1 1 0 0 0-1.175 0L4.073 15.78l1.657-5.1a1 1 0 0 0-.363-1.118L1.028 6.41h5.364a1 1 0 0 0 .95-.691L9 .619z"
        }
      ></path>
    </svg>
  );
}

export default StarIcon;
/* prettier-ignore-end */
